import React from 'react';

type KoobFeatureAccessProps = {
  /** Small line above the title (the feature's name). */
  eyebrow?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  /** What the feature brings, one check each. */
  features: React.ReactNode[];
  /** Picture beside the text from md up. */
  image?: string;
  /** The request button, or the request's state (a KoobBadge and a line). */
  action?: React.ReactNode;
};

// The page a feature shows to an organization without access yet: what it
// brings and how to request it (Trip Designer in DMC and TO).
export default function KoobFeatureAccess({
  eyebrow,
  title,
  description,
  features,
  image,
  action,
}: KoobFeatureAccessProps) {
  return (
    <div className="mx-auto w-full max-w-5xl py-6">
      <div className="grid overflow-hidden rounded-2xl border border-solid border-k-gray bg-white md:grid-cols-2">
        <div className="flex flex-col p-6 md:p-10">
          {eyebrow && (
            <div className="text-xs font-semibold uppercase tracking-wide text-orange-700">
              {eyebrow}
            </div>
          )}
          <h1 className="m-0 mt-2 text-2xl font-bold text-k-h">{title}</h1>
          {description && (
            <p className="m-0 mt-2 text-sm text-k-p">{description}</p>
          )}
          <ul className="m-0 mt-6 grid list-none gap-3 p-0 sm:grid-cols-2 md:grid-cols-1 lg:grid-cols-2">
            {features.map((feature, index) => (
              <li
                key={index}
                className="flex items-start gap-2.5 text-sm text-k-body"
              >
                <span className="mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full bg-orange-50 text-orange-700">
                  <i
                    className="fa-solid fa-check text-[9px]"
                    aria-hidden="true"
                  />
                </span>
                {feature}
              </li>
            ))}
          </ul>
          {action && <div className="mt-8">{action}</div>}
        </div>
        {image && (
          <div className="hidden bg-navy-50 md:block">
            <img src={image} alt="" className="h-full w-full object-cover" />
          </div>
        )}
      </div>
    </div>
  );
}
